import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";

const InvoiceActions = (props) => {

    const handleOpenEdit = () => {
        props.agGridReact.props.getEditDetails(props.data)
    };

    return (
        <>
            
            <Button
                onClick={handleOpenEdit}
                disabled={props.data.eway_bill_no && props.data.eway_bill_no!==""}
                basic
                size="mini"
                type="button"
                icon
                style={{ width: "25%"}}
            >
                <img src="assets/svg/extent.svg" width="100%" height="100%" />
            </Button>
        </>
    )
}

export default InvoiceActions;
